import React from 'react'

import { useSiteConfig } from '@thg-commerce/enterprise-core'
import { GlobalVideoHeroBannerWidget } from '@thg-commerce/enterprise-network/src/generated/graphql'
import {
  VideoHeroBanner,
  VideoHeroBannerProps,
} from '@thg-commerce/enterprise-widget-video-hero-banner'
import { mq, spacing, styled } from '@thg-commerce/gravity-theme'

import { BaseWidgetProps } from '../types'

export type VideoHeroBannerRendererProps = BaseWidgetProps &
  Omit<GlobalVideoHeroBannerWidget, 'query'>

const StyledVideoHeroBanner = styled(VideoHeroBanner)`
  margin: 0 auto ${spacing(4)}
  max-width: 1920px;
  
    ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-bottom: ${spacing(10)};
  }
`

export const VideoHeroBannerRenderer = (
  props: VideoHeroBannerRendererProps,
) => {
  const { hideVideoControl } = useSiteConfig()

  const hasVideo = Boolean(props.videoAssetPathMp4 || props.videoAssetPathWebm)
  if (!hasVideo) return null

  const videoHeroBannerProps = buildVideoHeroBannerProps(
    props,
    hideVideoControl ?? false,
  )
  return <StyledVideoHeroBanner {...videoHeroBannerProps} />
}

function buildVideoHeroBannerProps(
  props: VideoHeroBannerRendererProps,
  hideVideoControl: boolean,
): VideoHeroBannerProps {
  const optional = <T,>(value: T | null | undefined): T | undefined =>
    value ?? undefined

  const parseBoolean = (value?: string): boolean => value === 'true'

  return {
    hideVideoControl,
    videoTitle: { text: optional(props.videoTitle) },
    videoAssetPathMp4: optional(props.videoAssetPathMp4),
    videoAssetPathWebm: optional(props.videoAssetPathWebm),
    previewImage: {
      urls: {
        small: props.videoPreviewImageMobile,
        medium: props.VideoPreviewImageTablet,
        large: props.videoPreviewImage,
      },
    },
    muteVideo: parseBoolean(optional(props.muteVideo)),
    autoplayVideo: parseBoolean(optional(props.autoplayVideo)),
    transcript: optional(props.transcript?.content?.[0]?.content),
    videoCaptionPathVTT: optional(props.videoCaptionPathVTT),
    videoHeroHeadline: optional(props.videoHeroHeadline),
    videoHeroSubtitle: optional(props.videoHeroSubtitle),
    videoHeroCtaOneAriaLabel: optional(props.videoHeroCtaOneAriaLabel),
    videoHeroCtaTwoAriaLabel: optional(props.videoHeroCtaTwoAriaLabel),
    videoHeroCtaOneURL: optional(props.videoHeroCtaOneURL),
    videoHeroCtaTwoURL: optional(props.videoHeroCtaTwoURL),
    ctaOnVideoMobile: optional(props.ctaOnVideoMobile),
  }
}
